import http from '@/biz/http.mjs'

export default {
    create: (data) => http.post('/isrf/addIsrf', data),

    publish: ({memo, prjId, sVer, ...data}) => http.post(
        '/isrf/rlsIsrf',
        {memo, prjId, isrfs: [data], sVer}
    ),

    pull: ({pkid}) => http.get('/isrf/loadDp', {pkid}),
    push: (data) => http.post('/isrf/modifyDp', data),
    read: ({pkid}) => http.get('/isrf/oneIsrf', {pkid}),
    readList: (args) => http.get('/isrf/listIsrf', args),

    revise: ({prjId, sVer, ...data}) => http.post(
        '/isrf/reviseIsrf',
        {prjId, isrfs: [data], sVer}
    ),

    update: (data) => http.post('/isrf/modifyIsrf/', data),
    updateMap: (data) => http.post('/isrf/saveMap', data),
}
